"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsViewer = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var code_component_comp_1 = require("./components/code-component/code-component.comp");
var collapsible_component_comp_1 = require("./components/collapsible-component/collapsible-component.comp");
var heading_component_comp_1 = require("./components/heading-component/heading-component.comp");
var html_component_comp_1 = require("./components/html-component/html-component.comp");
var iframe_component_comp_1 = require("./components/iframe-component/iframe-component.comp");
var image_component_comp_1 = require("./components/image-component/image-component.comp");
var informative_component_comp_1 = require("./components/informative-component/informative-component.comp");
var line_component_comp_1 = require("./components/line-component/line-component.comp");
var markdown_component_comp_1 = require("./components/markdown-component/markdown-component.comp");
var step_by_step_component_comp_1 = require("./components/step-by-step-component/step-by-step-component.comp");
var table_component_comp_1 = require("./components/table-component/table-component.comp");
var text_component_comp_1 = require("./components/text-component/text-component.comp");
var video_component_comp_1 = require("./components/video-component/video-component.comp");
var namespace_classes_1 = require("../utils/namespace-classes");
var helpers_1 = require("./helpers");
var calc_direction_1 = require("../utils/calc-direction");
// tslint:disable-next-line: max-line-length
/** @deprecated - use <ArticleViewer/> instead - https://github.com/wix-private/wix-answers/tree/master/answers-client/common/article-viewer */
var ComponentsViewer = /** @class */ (function (_super) {
    tslib_1.__extends(ComponentsViewer, _super);
    function ComponentsViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            textCompListOffsets: {}
        };
        _this.renderArticleComponent = function (articleComponent, idx) {
            var renderedComponent = _this.renderComponent(articleComponent.type, articleComponent.value, idx);
            return _this.props.componentWrapper ? (_this.props.componentWrapper(renderedComponent, articleComponent)) : renderedComponent;
        };
        _this.mapFontConfigToCssVars = function () {
            var prefix = '--article-viewer';
            return _this.props.fontConfig ?
                Object.keys(_this.props.fontConfig).reduce(function (acc, key) {
                    acc[prefix + "-" + key] = _this.props.fontConfig[key];
                    return acc;
                }, {}) :
                {};
        };
        return _this;
    }
    ComponentsViewer.prototype.componentDidMount = function () {
        var _a = this.props, components = _a.components, onLinkClick = _a.onLinkClick;
        var textCompListOffsets = components.reduce(function (acc, _, idx) {
            var _a;
            var listOffset = helpers_1.getLastListItemCount(components, idx);
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[idx] = listOffset, _a));
        }, {});
        this.setState({ textCompListOffsets: textCompListOffsets });
        if (onLinkClick) {
            var linkElements = document.body.querySelectorAll('.components-viewer a');
            Array.from(linkElements).forEach(function (link) {
                var path = link.getAttribute('href') || '';
                link.addEventListener('click', function (e) { return onLinkClick(e, path); });
            });
        }
    };
    ComponentsViewer.prototype.renderComponent = function (type, value, idx) {
        var props = this.props;
        var listOffset = this.state.textCompListOffsets[idx] || 0;
        var direction = calc_direction_1.calcDirection(props.locale);
        switch (type) {
            case 'text':
                return React.createElement(text_component_comp_1.TextComponent, { key: idx, value: value, listOffset: listOffset });
            case 'line':
                return React.createElement(line_component_comp_1.LineComponent, { key: idx, value: value });
            case 'image':
                var maybeOnImgClick = props.onImgClick ? props.onImgClick.bind(this) : undefined;
                return React.createElement(image_component_comp_1.ImageComponent, { key: idx, value: value, onImgClick: maybeOnImgClick });
            case 'heading':
                return React.createElement(heading_component_comp_1.HeadingComponent, { key: idx, value: value });
            case 'informative':
                return React.createElement(informative_component_comp_1.InformativeComponent, { key: idx, value: value, direction: direction });
            case 'video':
                return React.createElement(video_component_comp_1.VideoComponent, { key: idx, value: value, direction: direction });
            case 'code':
                return React.createElement(code_component_comp_1.CodeComponent, { key: idx, value: value });
            case 'html':
                return React.createElement(html_component_comp_1.HtmlComponent, { key: idx, value: value });
            case 'collapsible':
                return React.createElement(collapsible_component_comp_1.CollapsibleComponent, { key: idx, value: value });
            case 'iframe':
                return React.createElement(iframe_component_comp_1.IframeComponent, { key: idx, value: value });
            case 'step-by-step':
                return React.createElement(step_by_step_component_comp_1.StepByStepComponent, { key: idx, value: value, locale: props.locale });
            case 'markdown':
                return React.createElement(markdown_component_comp_1.MarkdownComponent, { key: idx, value: value });
            case 'table':
                return React.createElement(table_component_comp_1.TableComponent, { key: idx, value: value, direction: direction });
            default:
                throw new Error("Tried to render unknown component into view: " + type);
        }
    };
    ComponentsViewer.prototype.render = function () {
        var components = this.props.components;
        var direction = calc_direction_1.calcDirection(this.props.locale);
        var classNames = namespace_classes_1.namespacedClassnames('components-viewer', direction);
        return (React.createElement("div", { className: classNames, style: this.mapFontConfigToCssVars() }, components.map(this.renderArticleComponent)));
    };
    return ComponentsViewer;
}(React.Component));
exports.ComponentsViewer = ComponentsViewer;
//# sourceMappingURL=components-viewer.comp.js.map